import { useState, useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Grid, Typography, IconButton, Box } from "@material-ui/core"
import { Add as AddIcon, Close as CloseIcon } from "@material-ui/icons"
import { documentsActions } from "../../actions/documentsActions"
import { operationsHelper } from "../../helpers/operations"
import { dataHelper } from "../../helpers/dataextraction"
import axios from "../../services/axios"
import { getCommentsCount, LIST_VIEW, METADATA } from "../../utils"
import { getDocumentsRequest, updateMetadata } from "../../actions/viewdocumentsActions"
import { getDocumentRowClickRequest } from "../../actions/documentModalActions"
import { useDebounce, PAGINATION_DELAY, DEFAULT_PAGE_SIZE, PAGE_OPTIONS } from "../../utils"
import TableView from "../../components/common/TableView/TableView"
import DocumentModal from "../../components/common/DocumentModal"
import { getAllDocumentsTableColumns } from "../ViewDocuments/ViewDocumentsUtility"
import CreateTag from "../../components/tags/CreateTag"
import TagSelect from "../../components/tags/TagSelect"
import EmailDialog from "../../components/common/dialog/Simple"
import ShowAllTags from "../../components/multiTag/ShowAllTags"
import MultiTagView from "../../components/multiTag/MultiTagView"
import { tagButtonClickedReset } from "../../actions/customTagsActions"
import DownloadAs from "../../components/common/dialog/DownloadAs"
import TaggedDate from "../../components/taggedDate/TaggedDate"
import TaggedDateDialog from "../../components/common/dialog/TaggedDateDialog"

export const BuildConcetsListView = ({
	filtersButton,
	page,
	setPage,
	pageCount,
	recordsPerPage,
	setRecordsPerPage,
	isEmailType,
	sortModel,
	setSortModel,
}) => {
	const SERVER_MODE = "server"
	// Translation
	const [t] = useTranslation("global")
	// Theme
	const theme = useTheme()
	/* ******************* REDUX STORE ******************* */
	const dispatch = useDispatch()
	const conceptDocs = useSelector((state) => state.buildconcept?.concept_docs) //

	const isConceptsTableLoading = useSelector((state) => state?.buildconcept?.loading_docs) //
	const conceptsDocCount = useSelector((state) => state?.buildconcept?.concept_docs?.count) //
	const alert = useSelector((state) => state.alert.alert)
	const tagsApi = useSelector((state) => state.tags.custom_tags)
	const updateCommentsRequest = useSelector((state) => state.document.reloadComments)
	const bulkDownloadStatus = useSelector((state) => state.downloads.bulk_download)
	const conceptUpdateLoad = useSelector((state) => state.buildconcept.loading)
	const { tagButtonClicked } = useSelector((state) => state.tags)
	const { selectedSearch } = useSelector((state) => state.savedSearch)
	const selectedRowFromRedux = useSelector((state) => state.downloads?.selectedDocumentIds)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	// Get Item Content
	const [item, setItem] = useState({
		idItem: "",
		contentItem: "",
	})
	const [open, setOpen] = useState(false)
	const [selectIdentify, setSelectIdentify] = useState({
		show: false,
		value: "",
		elementId: "",
		color: "",
	})
	const [selectDateDocument, setSelectDateDocument] = useState({
		show: false,
		date: "",
		elementId: "",
	})
	//Current hightlight text word index
	const [hightlightIndex, setHightlightIndex] = useState(null)
	const [showingCommentBoxId, setShowingCommentBoxId] = useState(null)
	const [userSelectedList, setUserSelectedList] = useState([])
	const [inputPageNumber, setInputPageNumber] = useState(page)
	// Create tag form popup
	const [showTagForm, setShowTagForm] = useState(false)
	// MultiTag Dialog
	const [multiTagDialogOpen, setMultiTagDialogOpen] = useState(false)
	const [multiTagDialogData, setMultiTagDialogData] = useState([])
	const [currFileId, setCurrFileId] = useState(null)
	//Download Dialog
	const [downloadDialogOpen, setDownloadDialogOpen] = useState(false)
	// Email Dialog
	const [emailDialogOpen, setEmailDialogOpen] = useState(false)
	const [emailDailogData, setEmailDailogData] = useState({})
	const [commentList, setCommentList] = useState([])
	// Tagged date update dialog
	const [taggedDateDialogOpen, setTaggedDateDialogOpen] = useState(false)
	const [tagDatedDialogData, setTagDatedDialogData] = useState({})
	/* ******************* END REACT STATES ******************* */
	const debouncedTerm = useDebounce(inputPageNumber, PAGINATION_DELAY)
	const wrapperRef = useRef(null)
	/* ******************* END VARIABLES ******************* */

	/* ******************* USE-EFFECTS ******************* */

	useEffect(() => {
		if (debouncedTerm !== "" && Number(debouncedTerm) >= 1 && Number(debouncedTerm) <= pageCount) setPage(Number(debouncedTerm))
		else {
			setInputPageNumber(page)
		}
	}, [debouncedTerm])

	//Reload comments when updating
	useEffect(() => {
		if (updateCommentsRequest === true) {
			updateCommentList(showingCommentBoxId)
			dispatch(documentsActions.updateCommentRequest(false))
		}
	}, [updateCommentsRequest])

	const updateCommentList = async (docId) => {
		const response = await axios.get(`/documents/comments/${docId}`)
		if (response.hasOwnProperty("data") && response.data.hasOwnProperty("data")) {
			setCommentList(response.data.data)
			dispatch(documentsActions.storeCommentCountRequest(docId, response.data.data.length))
		}

		return
	}

	//Close date modal when success
	useEffect(() => {
		if (alert && alert.type === "modal" && alert.class === "alert alert-success") {
			if (selectDateDocument.date) {
				setItem({ ...item, date: new Date(selectDateDocument.date).getTime() })
			}
			setSelectDateDocument({
				show: false,
			})
		}
	}, [alert])

	useEffect(() => {
		if (selectIdentify.elementId !== undefined && selectIdentify.elementId !== "") {
			try {
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("text-warning")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("text-danger")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("text-success")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("circleHidden")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).style.backgroundColor = operationsHelper.getTagColor(
					selectIdentify.value,
					tagsApi
				)
				document.getElementById(`doc_id_${selectIdentify.elementId}`).style.display = "block"
			} catch (e) {}
		}
	}, [selectIdentify])

	const useStyles = makeStyles((theme) => ({
		paper: {
			position: "absolute",
			width: "40%",
			height: "100%",
			backgroundColor: "#9dddd6",
			boxShadow: theme.shadows[5],
			padding: "16px 15px 24px",
		},
		emailDialogBox: {
			"& p": {
				paddingBottom: 2,
				...theme.typography.body2,
			},
			"& h6": {
				paddingBottom: 4,
				...theme.typography.body2,
				fontSize: "12px",
			},
		},
	}))

	const handleClose = () => {
		setOpen(false)
		setSelectIdentify({ ...selectIdentify, show: false })
		setSelectDateDocument({ ...selectDateDocument, show: false })
		setHightlightIndex(null)
		setShowingCommentBoxId(null)
	}

	const updateSelectIdentify = (tag_id, elementId) => {
		dispatch(documentsActions.setPriorityAction(elementId, tag_id))
		setSelectIdentify({
			value: tag_id,
			elementId: elementId,
		})
	}

	// SELECT DATE DOCUMENT
	const showSelectDateDocument = (e) => {
		e.preventDefault()
		if (!selectDateDocument.show) {
			setSelectDateDocument({
				show: true,
			})
			setSelectIdentify({
				show: false,
			})
		} else {
			setSelectDateDocument({
				show: false,
			})
		}
	}

	const updateSelectDateDocument = (e, docId) => {
		e.preventDefault()
		setSelectDateDocument({
			show: true,
			date: e.target.value,
			elementId: docId,
		})
	}

	const updateDateDocument = (e) => {
		e.preventDefault()
		dispatch(documentsActions.setDocumentDateAction(selectDateDocument.elementId, selectDateDocument.date))

		//update metadata in the list
		const data = {}
		data[METADATA.DATE] = selectDateDocument.date
		dispatch(updateMetadata({ id: selectDateDocument.elementId, data: data }))
	}

	// Get dates with yellow marked background
	const maskHightlight = (text, id) => {
		let markedText = operationsHelper.cleanHTMLTags(text)
		if (filtersButton.emails === true) {
			markedText = operationsHelper.highlightEmails(markedText, id)
		}

		if (filtersButton.dates !== false) {
			markedText = operationsHelper.hightlightDates(markedText, id)
		}

		if (filtersButton.searchWord.length !== 0 && filtersButton.specificWord === true) {
			markedText = operationsHelper.highlightWords(markedText, filtersButton.searchWord, id)
		}

		return { __html: markedText }
	}

	// OUTSIDE ALERTER
	/**
	 * Hook that alerts clicks outside of the passed ref
	 */
	const useOutsideAlerter = (ref) => {
		useEffect(() => {
			/**
			 * Alert if clicked on outside of element
			 */
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setSelectIdentify({ show: false })
					setSelectDateDocument({ show: false })
					setShowTagForm(false)
				}
			}

			// Bind the event listener
			document.addEventListener("mousedown", handleClickOutside)
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener("mousedown", handleClickOutside)
			}
		}, [ref])
	}

	/* ******************* END CUSTOM FUNCTIONS ******************* */

	/* ******************* VARIABLES POST INITIALIZATION ******************* */
	const classes = useStyles()
	/* ******************* END VARIABLES POST INITIALIZATION ******************* */

	/* ******************* FUNCTION CALL POST INITIALIZATION ******************* */
	useOutsideAlerter(wrapperRef)
	/* ******************* END FUNCTION CALL POST INITIALIZATION ******************* */

	//Scroll to next hightlight word
	const moveToHightlight = () => {
		try {
			var elementMark = document.getElementsByClassName("mark_element")
			var nextH
			if (hightlightIndex === null) {
				nextH = 0
			} else {
				nextH = (hightlightIndex + 1) % elementMark.length
			}
			setHightlightIndex(nextH)
			document.getElementById("divModal").scrollTop = elementMark[nextH].offsetTop - 100
		} catch (e) {}
	}

	const updateCommentCount = (id, commentCount) => {
		const data = {}
		data[METADATA.COMMENT] = commentCount
		dispatch(updateMetadata({ id: id, data: data }))
	}

	const openCreateTag = (e) => {
		setShowTagForm(!showTagForm)
		e.stopPropagation()
	}

	const getTags = (params) => {
		return (
			<MultiTagView
				view={LIST_VIEW}
				fileData={{ id: params?.row?.id, file_name: params?.row?.file_name, tags: params?.row?.tags }}
				tagState={{
					multiTagDialogData,
					multiTagDialogOpen,
					selectedSearch,
					setCurrFileId,
					setMultiTagDialogData,
					setMultiTagDialogOpen,
				}}
			/>
		)
	}

	const handlePageChange = (newPage) => {
		setPage(newPage)
	}

	const handlePageSizeChange = (newPageSize) => {
		setRecordsPerPage(newPageSize)
	}

	const handleSortModelChange = (newSortModel) => {
		if (!_.isEmpty(newSortModel)) {
			if (JSON.stringify(newSortModel) !== JSON.stringify(sortModel)) {
				setSortModel(newSortModel)
			}
		}
	}
	const renderEmailDialog = (params) => {
		return (
			<Typography
				variant="body2"
				onClick={() => {
					setEmailDialogOpen(true)
					setEmailDailogData({
						to: params?.row?.to,
						cc: params?.row?.cc || [],
						bcc: params?.row?.bcc || [],
					})
				}}
				style={{ cursor: "pointer" }}
			>
				{params?.row?.to?.length > 1 ? `${params?.row?.to?.[0]}...` : params?.row?.to}
			</Typography>
		)
	}

	const renderTagHeader = () => {
		return (
			<>
				<Typography variant="subtitle2" component="h2">
					{t("tag.title")}
				</Typography>
			</>
		)
	}

	const renderPageNumberHeader = () => {
		return (
			<>
				<Typography variant="subtitle2" component="h2" style={{ display: "flex", justifyContent: "end", width: "100%" }}>
					{t("tableColumns.pages")}
				</Typography>
			</>
		)
	}

	const renderTaggedDate = (params) => {
		return <TaggedDate data={params?.row} dialogData={{ taggedDateDialogOpen, setTaggedDateDialogOpen, setTagDatedDialogData }} />
	}

	const bulkDownloadEvent = () => {
		setDownloadDialogOpen(true)
	}
	const getRows = () => {
		return conceptDocs.count > 0
			? conceptDocs.data.map((docData) => {
					if (docData?.metadata?.source === "email") {
						return {
							...docData,
							id: docData?.file_id,
							subject: docData?.metadata?.subject || "NA",
							title: docData?.metadata?.title || docData?.name || "NA",
							author: docData?.metadata?.from || "NA",
							tags: docData?.tags || "NA",
							tagged_date: docData?.metadata?.tagged_date || "NA",
							view_count: docData?.viewed || 0,
							size: docData?.size || 0,
							comments_count: docData?.comments_count || 0,
							action: "",
							source: docData?.metadata?.source || "NA",
							to: docData?.metadata?.to || "NA",
							from: docData?.metadata?.from || "NA",
							cc: docData?.metadata?.cc || [],
							bcc: docData?.metadata?.bcc || [],
							attachments: docData?.children_files || [],
							pages: docData?.metadata?.total_page_number || 0,
						}
					} else
						return {
							...docData,
							id: docData?.file_id,
							title: docData?.metadata?.title || docData?.name || docData?.metadata?.filename || "NA",
							author: docData?.metadata?.author || "NA",
							tags: docData?.tags || "NA",
							tagged_date: docData?.metadata?.tagged_date || "NA",
							view_count: docData?.viewed || 0,
							size: docData?.size || 0,
							comments_count: docData?.comments_count || 0,
							action: "",
							source: docData?.metadata?.source || "NA",
							attachments: docData?.children_files || [],
							pages: docData?.metadata?.total_page_number || 0,
						}
			  })
			: []
	}

	useEffect(() => {
		dispatch(tagButtonClickedReset())
	}, [])

	const rows = getRows()

	return (
		<>
			<Grid container item className={classes.table} justifyContent="space-around" style={{ position: "relative" }}>
				<TableView
					columns={getAllDocumentsTableColumns(
						isEmailType,
						renderTagHeader,
						getTags,
						renderEmailDialog,
						() => {},
						rows,
						renderTaggedDate,
						renderPageNumberHeader
					)}
					rows={getRows()}
					isLoading={isConceptsTableLoading || conceptUpdateLoad}
					pageInfo={{
						paginationMode: SERVER_MODE,
						page: page,
						pageSize: recordsPerPage,
						rowsPerPageOptions: PAGE_OPTIONS,
						totalRowCount: conceptsDocCount,
						handlePageChange,
						handlePageSizeChange,
					}}
					sortInfo={{
						sortingMode: SERVER_MODE,
						sortModel: sortModel,
						onSortModelChange: handleSortModelChange,
					}}
					checkboxSelection={true}
					footerInfo={{
						hideFooter: false,
						hideSelectionCount: true,
						hidePagination: false,
					}}
					topBarInfo={{
						show: true,
						leftSection: `Total documents: ${conceptDocs?.count}`,
						rightSection: "",
					}}
					totalCountText={`${t("tableColumns.totalFiles")}:  ${conceptsDocCount}`}
					bulkDownloadEvent={bulkDownloadEvent}
					userSelectedRows={setUserSelectedList}
					bulkDownloadStatus={bulkDownloadStatus}
					showDownloadButton={true}
					showColumnsButton={false}
					toApplyHotKeys={!tagButtonClicked}
					showDuplicate={true}
				/>
				{showTagForm && <CreateTag innerRef={wrapperRef} show={showTagForm} />}
			</Grid>
			<div data-cy="element_modal">
				<DocumentModal
					open={open}
					handleClose={handleClose}
					selectDateDocument={selectDateDocument}
					wrapperRef={wrapperRef}
					updateSelectDateDocument={updateSelectDateDocument}
					updateDateDocument={updateDateDocument}
					updateSelectIdentify={updateSelectIdentify}
					showSelectDateDocument={showSelectDateDocument}
					maskHighlight={maskHightlight}
					moveToHighlight={moveToHightlight}
					updateCommentCount={updateCommentCount}
				/>
			</div>
			<EmailDialog
				open={emailDialogOpen}
				title={t("dialog.email.to")}
				onClose={() => {
					setEmailDialogOpen(false)
				}}
			>
				<Box className={classes.emailDialogBox}>
					{emailDailogData?.to?.map((emailTo, index) => {
						return <Typography key={`emailto-${index}`}>{emailTo}</Typography>
					})}
					{emailDailogData?.cc?.length > 0 && <Typography component="h6">{t("dialog.email.cc")}</Typography>}
					{emailDailogData?.cc?.map((cc, index) => {
						return <Typography key={`cc-${index}`}>{cc}</Typography>
					})}
					{emailDailogData?.bcc?.length > 0 && <Typography component="h6">{t("dialog.email.bcc")}</Typography>}
					{emailDailogData?.bcc?.map((bcc, index) => {
						return <Typography key={`bcc-${index}`}>{bcc}</Typography>
					})}
				</Box>
			</EmailDialog>
			<ShowAllTags
				tagState={{
					multiTagDialogData,
					multiTagDialogOpen,
					currFileId,
					selectedSearch,
					setMultiTagDialogData,
					setMultiTagDialogOpen,
					setCurrFileId,
				}}
			/>
			<DownloadAs
				open={downloadDialogOpen}
				title={t("downloadDialog.title")}
				handleBulkDownload={(source) => {
					const ids = Object.keys(selectedRowFromRedux)
					dispatch(documentsActions.downloadMultipleFileAction(ids, source))
				}}
				onClose={() => {
					setDownloadDialogOpen(false)
				}}
			/>
			<TaggedDateDialog
				open={taggedDateDialogOpen}
				title={t("taggedDateDialog.title")}
				onClose={() => {
					setTaggedDateDialogOpen(false)
				}}
				tagDatedDialogData={tagDatedDialogData}
			/>
		</>
	)
}
